var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.372,
    height: 17.829,
    viewBox: "0 0 13.372 17.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M6.334,8.918a3.36,3.36,0,0,1-.07-1.633C6.557,7.285,6.529,8.57,6.334,8.918Zm-.059,1.644a16.068,16.068,0,0,1-.989,2.183,12.823,12.823,0,0,1,2.19-.763A4.511,4.511,0,0,1,6.275,10.562ZM3,14.907c0,.028.46-.188,1.215-1.4A4.813,4.813,0,0,0,3,14.907ZM8.636,5.572h4.736V16.993a.834.834,0,0,1-.836.836H.836A.834.834,0,0,1,0,16.993V.836A.834.834,0,0,1,.836,0H7.8V4.736A.838.838,0,0,0,8.636,5.572Zm-.279,5.982A3.5,3.5,0,0,1,6.87,9.681a5.005,5.005,0,0,0,.216-2.236.872.872,0,0,0-1.665-.237A5.79,5.79,0,0,0,5.7,9.89a32.7,32.7,0,0,1-1.421,2.988s0,0-.007,0c-.944.484-2.563,1.55-1.9,2.368a1.082,1.082,0,0,0,.749.348c.623,0,1.243-.627,2.128-2.152a19.849,19.849,0,0,1,2.751-.808,5.277,5.277,0,0,0,2.229.679A.9.9,0,0,0,10.92,11.8C10.436,11.331,9.029,11.467,8.357,11.554Zm4.771-7.9L9.715.244A.835.835,0,0,0,9.123,0H8.914V4.457h4.457V4.245A.833.833,0,0,0,13.128,3.656Zm-2.58,8.89c.143-.094-.087-.414-1.49-.313C10.349,12.783,10.548,12.546,10.548,12.546Z",
    fill: "#e0001b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileRed);
export default __webpack_public_path__ + "static/media/file-red.e2c6f7b9fc9d6009a9a52e7d85272461.svg";
export { ForwardRef as ReactComponent };